export default "<div snInViewport (inViewportChange)=\"onInViewportChange($event)\">\n  <div [id]=\"containerId\"></div>\n</div>\n"